import { useRef, useState } from "react";
import { UploadCloud, Loader2, CheckCircle2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const FileUpload = ({ kind, label, value, onChange, multiple = false, accept = "image/jpeg,image/png,image/webp,application/pdf", testid }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const files = multiple ? value || [] : value ? [value] : [];

  const upload = async (e) => {
    const list = Array.from(e.target.files || []);
    e.target.value = "";
    if (!list.length) return;
    setBusy(true);
    try {
      const done = [];
      for (const f of list.slice(0, multiple ? 6 - files.length : 1)) {
        const fd = new FormData();
        fd.append("file", f);
        const { data } = await api.post(`/uploads?kind=${kind}`, fd);
        done.push({ path: data.path, name: f.name });
      }
      onChange(multiple ? [...files, ...done] : done[0]);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const remove = (i) => onChange(multiple ? files.filter((_, j) => j !== i) : null);

  return (
    <div className="space-y-2">
      <button
        type="button"
        onClick={() => ref.current?.click()}
        disabled={busy}
        data-testid={testid}
        className="w-full flex items-center gap-3 rounded-xl border-2 border-dashed border-border hover:border-primary/60 bg-muted/40 px-4 py-4 text-left transition-colors"
      >
        {busy ? <Loader2 className="h-5 w-5 animate-spin text-primary" /> : <UploadCloud className="h-5 w-5 text-primary" />}
        <span className="text-sm">
          <span className="font-semibold">{label}</span>
          <span className="block text-xs text-muted-foreground">JPG, PNG, WEBP{accept.includes("pdf") ? " or PDF" : ""} · max 5 MB</span>
        </span>
      </button>
      <input ref={ref} type="file" hidden accept={accept} multiple={multiple} onChange={upload} data-testid={`${testid}-input`} />
      {files.map((f, i) => (
        <div key={f.path} className="flex items-center gap-2 text-xs bg-secondary text-secondary-foreground rounded-lg px-3 py-2" data-testid={`${testid}-file-${i}`}>
          <CheckCircle2 className="h-4 w-4 text-primary" />
          <span className="truncate flex-1">{f.name}</span>
          <button type="button" onClick={() => remove(i)} aria-label="Remove file"><X className="h-4 w-4" /></button>
        </div>
      ))}
    </div>
  );
};
